import { Action, ThunkAction } from "@reduxjs/toolkit"
import { StoreState } from "../store/StoreState"
import { NavigateFunction } from "react-router"
import { isLoggedIn } from "@/services/authService"
import { ensureWishListsThunk } from "./wishThunks"
import { ensureSettingsThunk } from "./settingsThunks"
import { settingsActions } from "@/slices/settingsSlice"

export const startupThunk =
  (navigate: NavigateFunction): ThunkAction<void, StoreState, null, Action> =>
  async (dispatch, getState) => {
    await dispatch(ensureSettingsThunk(false))
    if (!isLoggedIn()) {
      navigate("login")
      await dispatch(settingsActions.setIsLoading(false))
      return
    }
    await dispatch(ensureWishListsThunk())
    await dispatch(settingsActions.setIsLoading(false))
  }
